import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-items-loading',
  standalone: true,
  imports: [NgClass],
  templateUrl: './items-loading.html',
  styleUrl: './items-loading.scss'
})
export class ItemsLoading {
  @Input() size: string = 'w-12 h-12';
  @Input() color: string = '#DC9D2A'; // default color
}
